import styled from "styled-components";

export const Wrapper = styled.div`
  background: #f1f3f5;
  padding: 0 5.208333333333333vw;
`;
